import { useEffect, useState } from "react"

export default function NetworkIndicator() {
  const [online, setOnline] = useState(navigator.onLine)
  useEffect(() => {
    const on = () => setOnline(true)
    const off = () => setOnline(false)
    window.addEventListener("online", on)
    window.addEventListener("offline", off)
    return () => {
      window.removeEventListener("online", on)
      window.removeEventListener("offline", off)
    }
  }, [])
  if (online) return null
  return <div className="bg-red-600 text-white text-center py-1 text-sm font-medium">Nema mrežne konekcije</div>
}
